import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {
  getSignedUrlWithCredentials,
  getSignedUrlWithPayload,
  postAnonymousVideoToAltru,
  postVideoToAltru,
  putVideoToSignedUrl,
} from '@/store/videos/api';
import { Answer, globalRegions } from 'altru-types';
import {
  GetSignedUrlResponse,
  PostVideoToAltruResponse,
  PutVideoToSignedUrlPayload,
  SignedUrlWithCredentials,
  SignedUrlWithPayload,
} from '@/store/videos/types';

@Module({ namespaced: true })
export default class VideosModule extends VuexModule {
  videoData: File | null = null;
  sessionFinished = false;
  responseConfigUrl = '';

  get video(): File | null {
    return this.videoData;
  }

  get isSessionFinished(): boolean {
    return this.sessionFinished;
  }

  get configUrl(): string {
    return this.responseConfigUrl;
  }

  @Mutation
  setVideoRecorded(value: File): void {
    this.videoData = value;
  }

  @Mutation
  setIsSessionFinished(): void {
    this.sessionFinished = true;
  }

  @Mutation
  setResponseConfigUrl(urlValue: string): void {
    this.responseConfigUrl = urlValue;
  }

  @Action
  storeConfigUrl(urlValue: string): void {
    this.context.commit('setResponseConfigUrl', urlValue);
  }

  @Action
  saveVideoToStore(file: File): void {
    this.context.commit('setVideoRecorded', file);
  }

  @Action
  async getSignedUrlWithPayload({ videoName, videoType, region, payload }: SignedUrlWithPayload): GetSignedUrlResponse {
    try {
      return await getSignedUrlWithPayload(videoName, videoType, region, payload);
    } catch (e) {
      return e.response.data;
    }
  }

  @Action
  async getSignedUrlWithCredentials({
    videoName,
    videoType,
    region,
    headers,
  }: SignedUrlWithCredentials): GetSignedUrlResponse {
    try {
      return await getSignedUrlWithCredentials(videoName, videoType, region, headers);
    } catch (e) {
      return e.response.data;
    }
  }

  @Action
  async putVideoToSignedUrl({ signedUrl, video }: PutVideoToSignedUrlPayload): Promise<void> {
    try {
      return await putVideoToSignedUrl(signedUrl, video);
    } catch (e) {
      return e.response;
    }
  }

  @Action({ rawError: true })
  async postVideoToAltru({
    payload,
    region,
  }: {
    payload: string;
    region: globalRegions;
  }): Promise<PostVideoToAltruResponse | null> {
    try {
      // TODO: in the future we want to move this condition from being iframed to being
      //  an "anonymous upload" flow, but for now we check for iframed status
      //  const isAnonymousUpload = this.context.rootState.auth.anonymousFlow ?? true;
      const isIframed = this.context.rootGetters['status/isIframed'];

      if (!isIframed) {
        return await postAnonymousVideoToAltru({ payload, region });
      } else {
        const headers = this.context.rootState.auth.credentials;
        const payloadAnswerId: Answer = this.context.rootGetters['answers/payloadAnswerInfo'];
        return await postVideoToAltru({ payload, region, answerId: payloadAnswerId.id, headers });
      }
    } catch (e) {
      return e.response.data;
    }
  }

  @Action
  finishSession(): void {
    this.context.commit('setIsSessionFinished');
  }
}
